import { withChartLayout } from 'components/common';
import DiagnosticTests from 'components/features/chart/order-entry/diagnostic-tests/DiagnosticTests';

const DiagnosticTestsPage = withChartLayout('Diagnostic Tests')(DiagnosticTests);
export default DiagnosticTestsPage;
